/**
 * Static constants used by ProductsPage.
 *
 * Extracted from ProductsPage.js to shrink that file and
 * make these lists reusable by the sub-components a future refactor
 * will pull out of the monolith.
 */
import { RATE_TYPES } from '../../components/admin/constants';

// Standard thickness options for Plywood (with 15MM added)
export const STANDARD_THICKNESSES = ['4MM', '6MM', '8MM', '9MM', '12MM', '15MM', '16MM', '18MM', '19MM'];

// Blockboard thicknesses
export const BLOCKBOARD_THICKNESSES = ['18MM', '19MM', '25MM', '30MM', '32MM', '42MM'];

// Adhesives weights
export const ADHESIVES_WEIGHTS = ['1KG', '2KG', '10KG', '20KG', '30KG', '50KG', '60KG'];

// Categories that use multi-thickness/weight bulk mode
export const THICKNESS_BULK_CATEGORIES = ['Plywood', 'Blockboard', 'Doors', 'WPC/PVC', 'MDF', 'Veneers', 'ACP'];

// Categories that use weight-based bulk mode (like Adhesives)
export const WEIGHT_BULK_CATEGORIES = ['Adhesives'];

// Standard sizes (in feet)
export const SIZE_OPTIONS = [
  { label: '10 x 4', value: '10x4', sqft: 40 },
  { label: '9 x 4', value: '9x4', sqft: 36 },
  { label: '8 x 4', value: '8x4', sqft: 32 },
  { label: '8 x 3', value: '8x3', sqft: 24 },
  { label: '7 x 4', value: '7x4', sqft: 28 },
  { label: '7 x 3', value: '7x3', sqft: 21 },
  { label: '6 x 4', value: '6x4', sqft: 24 },
  { label: '6 x 3', value: '6x3', sqft: 18 },
];

// Door sizes in INCHES (height x width)
export const DOOR_SIZE_OPTIONS = [
  { label: '81" x 28"', value: '81x28', sqft: (81 * 28) / 144 },
  { label: '81" x 32"', value: '81x32', sqft: (81 * 32) / 144 },
  { label: '84" x 30"', value: '84x30', sqft: (84 * 30) / 144 },
  { label: '84" x 36"', value: '84x36', sqft: (84 * 36) / 144 },
  { label: '84" x 39"', value: '84x39', sqft: (84 * 39) / 144 },
  { label: '84" x 42"', value: '84x42', sqft: (84 * 42) / 144 },
  { label: '84" x 48"', value: '84x48', sqft: (84 * 48) / 144 },
  { label: '96" x 30"', value: '96x30', sqft: (96 * 30) / 144 },
  { label: '96" x 32"', value: '96x32', sqft: (96 * 32) / 144 },
  { label: '96" x 36"', value: '96x36', sqft: (96 * 36) / 144 },
  { label: '96" x 39"', value: '96x39', sqft: (96 * 39) / 144 },
  { label: '96" x 42"', value: '96x42', sqft: (96 * 42) / 144 },
  { label: '96" x 48"', value: '96x48', sqft: (96 * 48) / 144 },
];

// Door thicknesses (same as Blockboard)
export const DOOR_THICKNESSES = ['25MM', '30MM', '32MM', '35MM', '40MM', '42MM', '45MM', '60MM'];

// Laminate-specific size options (per sheet)
export const LAMINATE_SIZE_OPTIONS = [
  { value: '8x4', label: '8 x 4', sqft: 32 },
  { value: '9x4', label: '9 x 4', sqft: 36 },
  { value: '10x4', label: '10 x 4', sqft: 40 },
  { value: '12x4', label: '12 x 4', sqft: 48 },
  { value: 'custom', label: 'Custom Size', sqft: 0 },
];

// Rate type options for Quick Add — use master list from constants
export const RATE_TYPE_OPTIONS = [
  ...RATE_TYPES.map(r => ({ value: r, label: r })),
  { value: 'custom', label: 'Custom...' },
];

// Size unit options with conversion to feet
export const SIZE_UNIT_OPTIONS = [
  { value: 'feet', label: 'Feet', toFeet: 1 },
  { value: 'inch', label: 'Inch', toFeet: 1 / 12 },
  { value: 'meter', label: 'Meter', toFeet: 3.28084 },
  { value: 'cm', label: 'CM', toFeet: 0.0328084 },
  { value: 'mm', label: 'MM', toFeet: 0.00328084 },
];
